module.exports = __webpack_public_path__ + "static/media/ta-grad-01.31964628.png";